@let routeData = routeData$ | async;

@if(routeData?.['title'] && routeData?.['title'] !== 'menu.home' && routeData?.['urls'] && routeData?.['urls'].length >
1){
  <div class="bg-white rounded p-20 m-b-30">
    <div class="row">
      <div class="col-sm-8">
        <h4 class="page-title m-0 f-s-18 f-w-600">
          {{ routeData?.['title'] | translate }}
        </h4>
      </div>
      <div class="col-sm-4">
        <div class="d-flex align-items-center justify-content-lg-end">
          <ul class="breadcrumb">
            @for (url of routeData?.['urls']; track url.url;let index = $index,last
          = $last ) {
              @if(!last){
                <li class="breadcrumb-item" [routerLink]="url.url">
                  <a [routerLink]="url.url" class="text-body-color">
                    @if(url.url === '/app') {
                      <mat-icon class="icon-24 breadcrumb-icon" [matTooltip]="'menu.home' | translate">home</mat-icon>
                    } @else {
                      {{ url.title | translate }}
                    }
                  </a>
                </li>
              } @else {
                <li class="breadcrumb-item">
                  <mat-icon class="icon-8">circle-filled</mat-icon>
                </li>
                <li class="breadcrumb-item active text-nowrap">
                  <span class="rounded p-x-8 p-y-2 text-primary bg-light-primary f-s-12 f-w-500">
                    {{ url.title | translate }}
                  </span>
                </li>
              } }
          </ul>
        </div>
      </div>
    </div>
  </div>
}